<script lang="ts">
  import {DropdownButton} from '@/components/button';
  import {IntegrationResiService} from '@/services/integrations/resi';
  import {ResiPlaylistFull} from '@/types/integrations';
  import {AllPlaylist, AllVideos} from './components';
  import {createEventDispatcher} from 'svelte';

  export let isUpdating: boolean;
  export let clientId: string;

  const resiService = new IntegrationResiService();
  const allPlaylistAsync = resiService.getAll();

  const dispatch = createEventDispatcher<{
    select: string;
  }>();

  let playlistAsync: Promise<ResiPlaylistFull> | undefined;

  const handleSelectPlaylist = (e: CustomEvent<string>) => {
    playlistAsync = resiService.getById(e.detail);
  };

  const handleSelectVideo = (e: CustomEvent<string>) => {
    dispatch('select', e.detail);
  };

  const handleGoBack = () => {
    playlistAsync = undefined;
  };
</script>

<div class="contents">
  {#if playlistAsync}
    <AllVideos {playlistAsync} on:click={handleSelectVideo} on:back={handleGoBack} />
  {:else}
    <AllPlaylist {allPlaylistAsync} on:click={handleSelectPlaylist} />
  {/if}
  <div class="mt-3 flex items-center justify-between border-t border-gray-200 pt-5">
    <a href="https://resi.io" target="_blank">
      <img
        class="h-10"
        src="https://storage.googleapis.com/sermonshots-local-storage/images/resi-logo.svg"
        alt="Resi.io logo"
      />
    </a>
    <div class="flex justify-end">
      <DropdownButton
        variant="simple"
        options={[
          {
            label: 'Update Credentials',
            value: 'update',
            onClick: () => {
              isUpdating = true;
            }
          }
        ]}
      >
        <span class="text-sm text-gray-400">{clientId}</span>
      </DropdownButton>
    </div>
  </div>
</div>
